var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-table',[_vm._t("header"),_c('tbody',_vm._l((_vm.items),function(item,index){return _c('AmountTableRow',{key:index + '-row',attrs:{"name":item.name,"amount":item.amount || item.total,"bold":item.bold,"mandatory":item.required,"button":item.click,"currency":item.filter != 'number'},on:{"click":_vm.handleClick}})}),1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }